import {
  StyledSystem,
  Tooltip as ManifestTooltip,
} from '@project44/manifest-ui-deprecated';

interface TooltipProps {
  children: React.ReactNode;
  disablePortal?: boolean;
  label: string;
  sx?: StyledSystem.SystemStyleObject;
  triggerStyle?: React.CSSProperties;
}

const styles: Record<'button', React.CSSProperties> = {
  button: {
    background: 'none',
    border: 'none',
    padding: 0,
    minWidth: 0,
    width: '100%',
    textAlign: 'left',
  },
};

function Tooltip({
  children,
  disablePortal = false,
  label,
  sx,
  triggerStyle,
}: TooltipProps) {
  return (
    <ManifestTooltip label={label} sx={{ ...sx }}>
      <button
        disabled={disablePortal}
        style={{ ...styles.button, ...triggerStyle }}
      >
        {children}
      </button>
    </ManifestTooltip>
  );
}

export default Tooltip;
